<script>
import { mapState } from 'vuex';
import { MuiNavbar } from '@ubeeqo/motion-ui';

export default {
  components: {
    MuiNavbar,
  },
  computed: {
    ...mapState('Setup', {
      assets: state => state.assets,
    }),
  },
};
</script>

<template>
  <div class="full-width full-height">
    <MuiNavbar
      fixed
      height="70"
      class="Navbar"
    >
      <template slot="center">
        <img
          :src="assets.navbar_logo"
        >
      </template>
    </MuiNavbar>
    <div class="m-6 pt-5">
      <RouterView />
    </div>
  </div>
</template>
